import React from "react";
export default function PlannerHeader({ dateScope, setDateScope, startOfDayMs, addDays,
  setSelectedDayMs, setCalendarAnchorMs, setCalendarExpanded, showClosed, setShowClosed,
  mode, setMode, SourceModeTabs, operationalControls }) {
  const scopeButtons = [["today","Today"],["tomorrow","Tomorrow"],["week","Week"],["month","Month"],["history","History"]];
  return <div className="schedule-toolbar" aria-label="Schedule controls">
    <div className="schedule-source-tabs"><SourceModeTabs mode={mode} setMode={setMode} /></div>
    <div className="schedule-scopes" aria-label="Date scope">
      {scopeButtons.map(([key,label]) => <button key={key} type="button" aria-pressed={dateScope === key}
        onClick={() => {
                const nextScope = String(key || "today").toLowerCase();

                setDateScope(nextScope);
                localStorage.setItem(
                  "shiftbridge_date_scope",
                  nextScope
                );

                window.dispatchEvent(
                  new CustomEvent(
                    "shiftbridge-date-scope-change",
                    {
                      detail: nextScope,
                    }
                  )
                );

                if (nextScope === "today") {
                  const todayMs = startOfDayMs(Date.now());
                  setSelectedDayMs(todayMs);
                  setCalendarAnchorMs(todayMs);
                  setCalendarExpanded(false);
                }

                if (nextScope === "tomorrow") {
                  const tomorrowMs = addDays(
                    startOfDayMs(Date.now()),
                    1
                  );
                  setSelectedDayMs(tomorrowMs);
                  setCalendarAnchorMs(tomorrowMs);
                  setCalendarExpanded(false);
                }

                if (
                  nextScope === "week" ||
                  nextScope === "month" ||
                  nextScope === "history"
                ) {
                  setCalendarExpanded(true);
                }
              }}>{label}</button>)}
    </div>
    <div className="schedule-secondary">
      <button type="button" aria-pressed={showClosed} onClick={() => setShowClosed(v => !v)}>
        {showClosed ? 'Hide Closed' : 'Show Closed'}
      </button>
      {operationalControls}
    </div>
  </div>;
}
